export enum TagEnum {
	'abbr',
	'accordion',
	'alert',
	'avatar',
	'badge',
	'breadcrumb',
	'button',
	'button-link',
	'card',
	'combobox',
	'details',
	'dialog',
	'drawer',
	'form',
	'heading',
	'icon',
	'image',
	'input-checkbox',
	'input-color',
	'input-date',
	'input-email',
	'input-file',
	'input-number',
	'input-password',
	'input-radio',
	'input-range',
	'input-text',
	'kolibri',
	'link',
	'link-button',
	'logo',
	'meter',
	'modal',
	'nav',
	'pagination',
	'popover-button',
	'progress',
	'quote',
	'select',
	'single-select',
	'skip-nav',
	'spin',
	'split-button',
	'symbol',
	'table',
	'table-stateful',
	'table-stateless',
	'tabs',
	'textarea',
	'toast-container',
	'toolbar',
	'tooltip',
	'tree',
	'tree-item',
}
